import { DEFAULT_COVER_IMG } from '@/common/components/HeadMetaTags/HeadMetaTags';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';

/**
 * @returns '/accessories'
 */
export const RouteToAboutContactPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: `/about-contact`, target: 'elysium' });
};

export const AboutContactPageConfig: PageConfig = {
  readableName: 'About Contact Page',
  analyticsGaName: 'about-contact',
  analyticsAthenaName: 'about-contact',
  pagePathnames: ['/about-contact'],
  displayPromoBar: false,
  defaultMeta: {
    title: `Contact Us | Displate`,
    description: `Got any questions regarding Displate? Contact us now!`,
    coverImage: DEFAULT_COVER_IMG,
  },
};
